import { createRouter, createWebHistory } from 'vue-router'


//Layouts
import PsychologistLayout from '@/layouts/psychologist/PsychologistLayout.vue'
import ClientLayout from '@/layouts/client/ClientLayout.vue'
import PublicLayout from '@/layouts/public/PublicLayout.vue'

//Pages
import WelcomeView from '@/views/public/WelcomeView.vue'
import AboutView from '@/views/public/AboutView.vue'
import AnswerEvaluationView from '@/views/public/AnswerEvaluationView.vue'
import LoginView from '@/views/auth/LoginView.vue'
import PsychologistDashboard from '@/views/psychologist/PsychologistDashboard.vue'
import PsychologistClients from '@/views/psychologist/PsychologistClients.vue'
import ClientDashboard from '@/views/client/ClientDashboard.vue'
import ClientEvaluations from '@/views/client/ClientEvaluations.vue'
import PsychologistEvaluations from '@/views/psychologist/PsychologistEvaluations.vue'
import PsychologistNewEvaluationView from '@/views/psychologist/PsychologistNewEvaluationView.vue'
import PsychologistViewEvaluationView from '@/views/psychologist/PsychologistViewEvaluationView.vue'
import PsychologistSettingsView from '@/views/psychologist/PsychologistSettingsView.vue'
import PsychologistViewClientView from '@/views/psychologist/PsychologistViewClientView.vue'
import StartEvaluationView from '@/views/public/StartEvaluationView.vue'
import ThankYou from '@/views/public/ThankYou.vue'

import { appStore } from '@/stores/AppStore'

const routes = [

  //----------------------------Public routes-----------------------------------
  {
    path: '/',
    // name: 'Welcome',
    component: PublicLayout,
    children: [
      { 
        path: '', 
        component: WelcomeView 
      },
      { 
        path: '/login', 
        component: LoginView,
        beforeEnter: (to, from, next) => {
          const store = appStore()
          // store.initAuth() // Load auth state from localStorage
          if (store.isLoggedIn && store.getUser?.role) {
              console.log('User is logged in, redirecting based on role...role:', store.getUser.role)
              // Redirect based on user role
              switch (store.getUser.role) {
                  case 'admin':
                      next('/admin')
                      break
                  case 'therapist':
                  case 'psychologist':
                      next('/psychologist')
                      break
                  case 'client':
                      next('/client')
                      break
                  default:
                      next() // Unknown role, stay on home
              }
          } else {
              next() // Not logged in, show public page
          }
        }, //end  beforeEnter
      },
      { 
        path: '/about', 
        component: AboutView 
      },
      {
        path: '/evaluation/:token',
        component: StartEvaluationView,        
      },
      {
        path: '/evaluation/:token/questionnaire',
        name: 'Questionnaire',
        component: AnswerEvaluationView
      },
      {
        path: '/evaluation/thankYou',
        component: ThankYou,        
      },
    ],

  },
  

  // Psychologist routes
  {
    path: '/psychologist',
    component: PsychologistLayout,
    meta: { requiresAuth: true, roles: ['psychologist'] },
    children: [
      { path: '', component: PsychologistDashboard },
      { path: 'dashboard', component: PsychologistDashboard },
      { path: 'evaluations', component: PsychologistEvaluations },      
      { path: 'newEvaluation', component: PsychologistNewEvaluationView },      
      { path: 'viewEvaluation/:token', component: PsychologistViewEvaluationView },      
      { path: 'clients', component: PsychologistClients },      
      { path: 'settings', component: PsychologistSettingsView },      
      { path: 'viewClient/:clientId', component: PsychologistViewClientView },      
    ]
  },


  // Client routes
  {
    path: '/client',
    component: ClientLayout,
    meta: { requiresAuth: true, roles: ['client'] },
    children: [
      { path: '', component: ClientDashboard },
      { path: 'dashboard', component: ClientDashboard },
      { path: 'evaluations', component: ClientEvaluations },      
    ]
  },
]

const router = createRouter({  
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // Direct check - same logic as your store's initAuth()
    const token = localStorage.getItem('authToken')
    const isLoggedIn = token !== null
    
    console.log(`Router > beforeEach > isLoggedIn: ${isLoggedIn} to: ${to} from: ${from}`)
    if (!isLoggedIn) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})


// // utils/routeAuth.js
// export function checkRouteAuth(route, authStore) {
//   // Colectează toate meta-urile din ierarhia de rute
//   const allMeta = route.matched.map(record => record.meta)
  
//   // Verifică dacă oricare din rute necesită autentificare
//   const requiresAuth = allMeta.some(meta => meta.requiresAuth)
  
//   // Colectează toate rolurile permise
//   const allowedRoles = allMeta
//     .filter(meta => meta.roles)
//     .flatMap(meta => meta.roles)
  
//   return {
//     requiresAuth,
//     hasValidRole: !allowedRoles.length || allowedRoles.includes(authStore.user?.role),
//     isAuthenticated: authStore.isAuthenticated
//   }
// }

// // În router guard
// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore()
//   const { requiresAuth, hasValidRole, isAuthenticated } = checkRouteAuth(to, authStore)
  
//   if (requiresAuth && !isAuthenticated) {
//     next('/login')
//   } else if (requiresAuth && !hasValidRole) {
//     next('/unauthorized')
//   } else {
//     next()
//   }
// })

export default router